import { take, call, put, cancelled } from 'redux-saga/effects';

import {
  ACTIVATION_START,
  ACTIVATION_PASSWORD_START,
  // ACTIVATION_SUCCESS,
  // ACTIVATION_ERROR,
} from '../actions';

angular.module('tct.sagas.activation', [])
  .factory('activationSagaFactory', activationSagaFactory);

activationSagaFactory.$inject = ['$ngRedux',
  'actionsFactory',
  'activationService',
  'configService',
];

function activationSagaFactory($ngRedux, actionsFactory, activationService, config) {
  const factory = {
    activationFlow,
  };

  return factory;

  function* activationFlow() {
    while (true) {
      const activationAction = yield take([ACTIVATION_START, ACTIVATION_PASSWORD_START]);
      try {
        if (activationAction.type === ACTIVATION_START) {
          const response = yield call(activationService.activate, activationAction.token);
          yield put(actionsFactory.reqActivationSuccess(response.data.data));
        } else {
          yield call(activationService.sendPassword, activationAction.token,
            activationAction.password, activationAction.password_confirmation);
          yield put(actionsFactory.finishActivation());
        }
      } catch (err) {
        if (activationAction.type === ACTIVATION_START) {
          yield put(actionsFactory.reqActivationError(
            (err.data && err.data.error && err.data.error.message) || config.ERR_GENERIC));
        } else {
          yield put(actionsFactory.sendActivationPasswordError(
            (err.data.errors && err.data.errors.password[0]) || config.ERR_GENERIC));
        }
      } finally {
        if (yield cancelled()) {
          console.log('cancelled');
        }
      }
    }
  }
}
